import {DevicePricingItem} from "../../../../../../domain/in/quote/pricing-item/device-pricing-item";
import {PricingItem} from "../../../../../../domain/in/quote/pricing-item/pricing-item";
import {PricingItemSummary} from "../../../../../../domain/out/pricing-item-summary";
import {AbstractPricingItemSummaryMapper} from "../../abstract-pricing-item-summary.mapper";
import {MappingContext} from "../../mapping-context";

export class FrCaIcsVtVtSynthesisMapper extends AbstractPricingItemSummaryMapper {

    protected async doMap(pricingItem: PricingItem, ctx: MappingContext): Promise<PricingItemSummary> {
        let devicePricingItem = pricingItem as DevicePricingItem;
        let pricingItemSummary = new PricingItemSummary();
        pricingItemSummary.codeElis = await ctx.resolveCodeElis(devicePricingItem.device.codeElis);
        pricingItemSummary.label = this.getLabel(devicePricingItem);
        pricingItemSummary.quantity = devicePricingItem.userInputs.quantity;
        pricingItemSummary.numberOfChange = devicePricingItem.userInputs.numberOfChange;
        pricingItemSummary.appliedPrice = ctx.formatAmount(devicePricingItem.device.appliedPrice);
        pricingItemSummary.totalAppliedPrice = ctx.formatAmount(devicePricingItem.totalAppliedPrice);
        pricingItemSummary.frequency = await ctx.getFrequency(devicePricingItem);
        pricingItemSummary.unitStockInitialVT = Number.isNaN(Number(devicePricingItem.unitStockInitialVT)) ? '-' : devicePricingItem.unitStockInitialVT;
        pricingItemSummary.totalStockInitialVT = devicePricingItem.totalStockInitialVT;
        pricingItemSummary.family = devicePricingItem.family;
        return pricingItemSummary;
    }

    getLabel(devicePricingItem: DevicePricingItem) {
        return devicePricingItem.device.label;
    }
}
